import type React from "react"
import { Spin, Typography, Button } from "antd"
import { LoadingOutlined, StopOutlined } from "@ant-design/icons"

const { Title, Paragraph } = Typography

interface GenerateStepProps {
  currentLoadingMessage: string
  onCancel?: () => void
}

export const GenerateStep: React.FC<GenerateStepProps> = ({ currentLoadingMessage, onCancel }) => {
  return (
    <div className="text-center py-12 mt-4">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} className="mb-8" />
      <Title level={3} className="mb-6">
        {currentLoadingMessage}
      </Title>
      <Paragraph className="text-gray-500 mb-6">
        Our AI is analyzing your prompt and generating relevant tags. This may take a moment...
      </Paragraph>

      {onCancel && (
        <Button icon={<StopOutlined />} danger onClick={onCancel} className="mt-4">
          Cancel Generation
        </Button>
      )}
    </div>
  )
}
